import React, { useEffect } from 'react';
import './Blog.css';
import Header from "../components/Header";
import Footer from "../components/Footer";
import img from "../assets/Sameed1.webp"
import img1 from "../assets/Moeed.webp"

const AboutSakaeStudio = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <section className="bg-white py-12 pt-32">  
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Hero Section */}
          <div className="text-center mb-16">
            <h1
              className="text-5xl md:text-6xl font-bold mb-6"
              style={{ color: "#006039" }}
            >
              About <span style={{ color: "#006039" }}>Sakae Studio</span>
            </h1>
            <p
              className="text-2xl font-medium"
              style={{ color: "#000000" }}
            >
              Opulent Architecture | Precision Execution
            </p>
          </div>

          {/* Featured Image */}
          <div className="mb-16 rounded-xl overflow-hidden shadow-xl">
            <img
              src="https://images.unsplash.com/photo-1487958449943-2429e8be8625?ixlib=rb-4.0.3&auto=format&fit=crop&w=1600&q=80"
              alt="Sakae Studio Architectural Design"
              className="w-full h-auto object-cover"
            />
          </div>

          {/* Main Content */}
          <div className="prose prose-lg max-w-4xl mx-auto text-gray-700">
            
            {/* Company Overview */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ color: "#006039" }}>Redefining Architectural Excellence</h2>
              <p className="text-lg leading-relaxed mb-6">
              Sakae Studio Private Limited is a premier architectural and engineering consultancy offering bespoke, end-to-end solutions for luxury residential, commercial, and urban design projects. With a commitment to innovation, quality, and trust, we blend opulent architecture with precise execution. Our portfolio spans India and international markets, creating contextually rich spaces that push design boundaries.              </p>
            </div>

            {/* Legacy Section */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ color: "#006039" }}>A Legacy of Engineering Excellence</h2>
              <p className="text-lg leading-relaxed mb-6">
              As a subsidiary of Technocrats—a trusted name with 34+ years in architectural and civil engineering consultancy—Sakae benefits from a deep legacy of structural expertise. We deliver design-build solutions that marry architectural creativity with engineering integrity, offering timeless designs that are both elegant and technically sound.              </p>
            </div>

          

            {/* Design Solutions */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ color: "#006039" }}>End-to-End Design & Execution</h2>
              <p className="text-lg leading-relaxed mb-6">
              From concept and approvals to visualization, execution, and post-completion management, our turnkey approach ensures seamless coordination across all stages. Whether it’s a bespoke villa, commercial space, or large-scale urban development, we deliver refined, purposeful spaces that stand the test of time.              </p>
            </div>


            {/* Process Image */}

            {/* Process Image */}
            <div className="mb-12 rounded-xl overflow-hidden shadow-lg">
            <div>
  <img
    src={require('../assets/S33.webp')}
    alt="Sakae Studio Design Process"
    className="w-full h-auto object-cover"
  />
</div>

            </div>

            {/* Innovation Section */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ color: "#006039" }}>Innovative Methodologies</h2>
              <p className="text-lg leading-relaxed mb-6">
              We stay at the forefront of technology, using Building Information Modeling (BIM) and Virtual Reality walkthroughs for precision and immersive client experiences. Our sustainability team focuses on green building certifications and energy-efficient solutions, backed by a multi-stage quality assurance system that ensures every project meets our exacting standards.              </p>
            </div>

            {/* Offices Section */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ color: "#006039" }}>Our Offices</h2>
              <div className="grid md:grid-cols-2 gap-8">
                <div className="bg-gray-50 p-6 rounded-lg shadow-md">
                  <h3 className="text-xl font-bold mb-3" style={{ color: 'black' }}>Banjara Hills Studio</h3>
                  <p className="text-gray-700 leading-relaxed">
                    10-5-2/F/G/7,8,9, Sarda Sadan,<br />
                    Opp. Balaji Grand Bazaar, Road No.1,<br />
                    Banjara Hills, Hyderabad – 500034<br />
                    <span className="font-medium">Phone:</span> +91 40 1234 5678
                  </p>
                </div>
                <div className="bg-gray-50 p-6 rounded-lg shadow-md">
                  <h3 className="text-xl font-bold mb-3" style={{ color: 'black' }}>Head Office – Vidyanagar</h3>
                  <p className="text-gray-700 leading-relaxed">
                    Technocrats Residency,<br />
                    Vidyanagar, Hyderabad – 500044<br />
                    <span className="font-medium">Phone:</span> +91 40 2345 6789<br />
                    <span className="font-medium">Email:</span> info@sakaestudio.com
                  </p>
                </div>
              </div>
            </div>

            {/* Board of Directors Section */}
            <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" style={{ color: "#006039"}}>Board of Directors</h2>
              
              {/* Chairman Profile */}
              <div className="bg-gray-50 p-8 rounded-lg shadow-md mb-8">
                <div className="flex flex-col md:flex-row gap-6 items-start">
                  <div className="md:w-1/4">
                    <img
                      src={img1}
                      alt="M. A. Moeed Khan"
                      className="rounded-lg shadow-lg w-full h-auto"
                    />
                  </div>
                  <div className="md:w-3/4">
                    <h3 className="text-2xl font-bold mb-2" style={{ color: 'black' }}>M. A. Moeed Khan</h3>
                    <p className="text-lg font-medium text-gray-600 mb-2">Chairman</p>
                    <p className="text-sm text-gray-500 mb-4">B.Tech (Civil), D.Arch, MBA</p>
                    <p className="text-gray-700 leading-relaxed">
                      With over three decades of experience in architecture, engineering, and construction, M. A. Moeed Khan brings unmatched depth and leadership to Sakae Studio. His portfolio spans private and government sector projects across all scales, showcasing a refined balance between technical expertise and visionary design thinking. As Chairman, Mr. Khan leads with a commitment to integrity, precision, and timeless design. His background in civil engineering, architecture, and management allows him to orchestrate complex developments with strategic insight and operational excellence.
                    </p>
                  </div>
                </div>
              </div>

              {/* Managing Director Profile */}
              <div className="bg-gray-50 p-8 rounded-lg shadow-md mb-8">
                <div className="flex flex-col md:flex-row gap-6 items-start">
                  <div className="md:w-1/4">
                    <img
                      src={img}
                      alt="Sameed Ahmed Khan"
                      className="rounded-lg shadow-lg w-full h-auto"
                    />
                  </div>
                  <div className="md:w-3/4">
                    <h3 className="text-2xl font-bold mb-2" style={{ color: 'black' }}>Sameed Ahmed Khan</h3>
                    <p className="text-lg font-medium text-gray-600 mb-2">Founder & Managing Director</p>
                    <p className="text-sm text-gray-500 mb-4">B.Arch, M.Arch (Urban Design), BIM</p>
                    <p className="text-gray-700 leading-relaxed">
                      Sameed Ahmed Khan is the Founder and Managing Director of Sakae Studio Pvt. Ltd., leading the firm's vision of delivering opulent, context-driven, and technologically advanced design solutions. With academic credentials in Architecture, Urban Design, and BIM, he brings a multidisciplinary approach that blends creative vision with technical depth. Sameed plays a pivotal role in driving the studio's growth across luxury residences, commercial developments, urban design projects, and strategic master planning.
                    </p>
                  </div>
                </div>
              </div>

              {/* Finance Director Profile */}
              <div className="bg-gray-50 p-8 rounded-lg shadow-md mb-8">
                <h3 className="text-2xl font-bold mb-2" style={{ color: 'black' }}>Massarath Khan</h3>
                <p className="text-lg font-medium text-gray-600 mb-2">Finance Director</p>
                <p className="text-gray-700 leading-relaxed">
                  Massarath Khan serves as the Finance Director of Sakae Studio Pvt. Ltd., overseeing the financial strategy, planning, and governance of the firm. With strong acumen in financial management, budgeting, and corporate compliance, she plays a crucial role in ensuring the company's growth is both sustainable and strategically aligned. Her leadership is integral to maintaining the financial integrity of Sakae's wide-ranging portfolio—from private luxury developments to large-scale government projects.
                </p>
              </div>
            </div>

            {/* Future Vision */}
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-4" style={{ color: "#006039" }}>Building the Future</h2>
              <p className="text-lg leading-relaxed">
                Sakae Studio continues to push boundaries with research-driven design and material innovation. Our upcoming initiatives include developing modular construction techniques and exploring AI-assisted design processes. With numerous awards and featured publications, we remain committed to our core philosophy: creating architecture that elevates human experience while respecting environmental responsibilities. The studio welcomes collaborations with clients and partners who share our passion for transformative design.
              </p>
            </div>

          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default AboutSakaeStudio;